import { render, staticRenderFns } from "./BillTable.vue?vue&type=template&id=4706a259&scoped=true&"
import script from "./BillTable.vue?vue&type=script&lang=js&"
export * from "./BillTable.vue?vue&type=script&lang=js&"
import style0 from "./BillTable.vue?vue&type=style&index=0&id=4706a259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706a259",
  null
  
)

export default component.exports